import { jsx } from 'react/jsx-runtime';
import { useSwipeable } from 'react-swipeable';
const Swipeable = ({
  className,
  delta,
  onSwiping,
  onSwiped,
  children,
  dataAttributeControl
}) => {
  const handler = useSwipeable({
    onSwiping,
    onSwiped,
    delta
  });
  return jsx("div", {
    ...handler,
    "data-control": dataAttributeControl,
    className: className,
    children: children
  });
};
export { Swipeable };